import { render, staticRenderFns } from "./LogBowelMovement.vue?vue&type=template&id=81005474&scoped=true&"
import script from "./LogBowelMovement.vue?vue&type=script&lang=js&"
export * from "./LogBowelMovement.vue?vue&type=script&lang=js&"
import style0 from "./LogBowelMovement.vue?vue&type=style&index=0&id=81005474&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81005474",
  null
  
)

export default component.exports